// import { Bot, IBot } from "../bot";
import { Customer } from "..";
import { ICustomerData } from "../customer";
import { ISale, ISaleData } from "./sale.types";
export class Sale implements ISale {
    readonly id?: string;
    firstname?: string | undefined;
    lastname?: string | undefined;
    branch?: string | undefined;
    customers: Customer[];
    // bots?: Array<IBot>;

    constructor(data: any) {
        if (data.id) {
            this.id = data.id;
        }

        if (data.firstname) {
            this.firstname = data.firstname;
        }

        if (data.lastname) {
            this.lastname = data.lastname;
        }

        if (data.branch) {
            this.branch = data.branch;
        }

        this.customers = [];
        if (data.customers) {
            if(data.customers.items){   
                console.log({data});
                this.customers = (data.customers.items as Array<any>)?.map((c) => {
                    const nc = new Customer(c["customer"]);
                    nc.saleID = c["id"];
                    return nc;
                });
            }
        }
    }

    validate(): boolean {
        if ([null, undefined, ""].indexOf(this.id) >= 0) {
            return false;
        }
        return true;
    }

    data(): ISaleData {
        return Object.assign({}, this);
    }

    customerList(): ICustomerData[] {
        for (let index = 0; index < this.customers.length; index++) {
            const element = this.customers[index];
            console.log(element.id);
        }
        return this.customers.map((x) => x.data());
    }
}
